<template>
  <div class="block-flex">
    <div
      v-for="(item, index) in journeyMaps"
      :key="index"
      class="flex-nav"
      @click="handleClick(item)"
      :class="{ cur: item.name === currentJourneyTxts }"
    >
      <img
        v-if="item.state === '2'"
        src="../../../assets/images/cartojourney/img15.png"
        class="img-close"
        alt="关闭"
      />
      <template v-if="item.state !== '2' && item.manualUnlockSign !== 1">
        <!-- 状态：1:已完成 2:进行中 3：未开始 -->
        <div class="icon-tag icon-ingjourney" v-if="item.learningStatus === '2'"
             :class="item.name === currentJourneyTxts ? 'icon-cur' : ''">
          当前旅程
        </div>
        <div class="icon-tag icon-journey" v-else-if="item.learningStatus === '1'">
          已过关
        </div>
        <div class="icon-tag icon-edjourney" v-else-if="item.learningStatus === '3'">
          未开始
        </div>
      </template>
      <div class="txt">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'JourneySelector',
  props: {
    // 旅程列表
    journeyMaps: {
      type: Array,
      required: true
    },
    // 当前选中的旅程文本
    currentJourneyTxts: {
      type: String,
      default: ''
    },
    // 点击事件处理函数
    handleChangeJourney: {
      type: Function,
    },
    isSurgeon: {
      default: false
    }
  },
  methods: {
    handleClick(item) {
      if (item.state === '2') {
        this.$emit('unlockJourney', item)
      }
      this.$emit('change', item) // 触发父组件的 change 事件
    }
  }
}
</script>

<style lang="less" scoped>
.block-flex {
  display: flex;
  width: 100%;
  padding-left: 10px;
  box-sizing: border-box;
  overflow-y: auto;

  .flex-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    box-sizing: border-box;
    width: 90px;
    height: 62px;
    position: relative;
    background-image: url("../../../assets/images/cartojourney/img14.png");
    background-size: 100% 100%;
    cursor: pointer;

    &.cur {
      height: 70px;
      background-image: url("../../../assets/images/cartojourney/img13.png");

      .txt {
        color: #fff;
        position: relative;
        top: -2px;
      }
    }

    &:nth-last-child(1) {
      padding: 0 8px;
    }

    &:nth-child(1) {
      padding: 0 8px;
    }

    .img-close {
      width: 20px;
      position: absolute;
      bottom: 3px;
      left: 3px;
    }

    .txt {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 14px;
      color: #eb1700;
      line-height: 16px;
      text-align: center;
    }

    .icon-tag {
      position: absolute;
      left: 0;
      top: 0;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 10px;
      color: #FFFFFF;
      height: 14px;
      line-height: 14px;
      text-align: center;
      border-radius: 10px 2px;

      &.icon-ingjourney {
        width: 52px;
        background-color: rgba(235, 23, 0, 1);
      }

      &.icon-cur {
        background-color: rgba(235, 23, 0, .4);
      }

      &.icon-journey {
        background-color: rgba(235, 23, 0, 0.30);
        width: 43px;
      }

      &.icon-edjourney {
        background-color: rgba(198, 202, 221, 1);
        width: 43px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/components/JourneySelecto.vue